<template>
  <header
    id="header"
    class="wrapper"
  >
    <nav class="atlas-navbar-header">
      <div class="row header-container">
        <div class="header-container__logo">
          <a
            class="logo"
            :href="settings.link_main_website_href"
          >
            <img
              src="../assets/images/tbo_logo_white-horizontal.svg"
              alt="Atlas Logo Full"
              class="atlas-logo-walkup"
            >
            <img
              src="../assets/images/tbo_logomark.svg"
              alt="Atlas Logo Full"
              class="atlas-logo-mobile"
            >
          </a>
        </div>
      </div>
      <div class="atlas-steps-container">
        <div style="font-weight: 500; color: rgba(0,0,0,.12); text-align: right;">
          {{ version }}
        </div>

        <img
          v-if="$route.name === 'step-1'"
          src="../assets/images/step_image_1.png"
          alt="Walkup first step"
          class="walkup-first-step walkup-first-step-1"
        >

        <img
          v-else-if="$route.name === 'step-2'"
          src="../assets/images/step_image_2.png"
          alt="Walkup second step"
          class="walkup-first-step walkup-first-step-2"
        >

        <img
          v-else-if="$route.name === 'step-3'"
          src="../assets/images/step_image_3.png"
          alt="Walkup third step"
          class="walkup-first-step walkup-first-step-3"
        >

        <img
          v-else-if="$route.name === 'step-4'"
          src="../assets/images/step_image_4.png"
          alt="Walkup first step"
          class="walkup-first-step walkup-first-step-4"
        >
        <div v-else />
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("settings", ["settings", "version"]),
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  display: flex;
  justify-content: space-between;
}

.steps-container {
  display: flex;
}
</style>
